// auth.js 页面

// 获取token
export function getToken() {
  return localStorage.getItem('BoooleanDAToken')
}
// 设置token
export function setToken(token) {
  return localStorage.setItem('BoooleanDAToken', token)
}
// 删除token
export function removeToken() {
  return localStorage.removeItem('BoooleanDAToken')
}
